<template>
	<div>
		<el-drawer
			:title="`${data.assetName} - 资产详情`"
			:visible.sync="dialogVisible"
			size="45%"
			:close-on-click-modal="false"
			:before-close="handleClose"
			destroy-on-close>
			<div class="drawer-content">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="基本信息" name="1" lazy>
						<AssetLedgerBaseInfo v-on="$listeners" :data="detailData" />
					</el-tab-pane>
					<el-tab-pane :label="assetChangeTitle" name="2" lazy>
						<AssetLedgerDynamicRecording :data="detailData.assetChangeList" />
					</el-tab-pane>
					<el-tab-pane :label="assetResourceTitle" name="3" lazy>
						<AssetLedgerRelatedResource :data="detailData.resourceList" />
					</el-tab-pane>
					<el-tab-pane label="规划信息" name="4" lazy>
						<AssetLedgerPlanningInfo :data="detailData.assetPlanList" />
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import { getAssetById } from '@/api/asset/assetLedgerApi.js';
	import AssetLedgerBaseInfo from './assetLedgerBaseInfo.vue';
	import AssetLedgerDynamicRecording from './assetLedgerDynamicRecording.vue';
	import AssetLedgerRelatedResource from './assetLedgerRelatedResource.vue';
	import AssetLedgerPlanningInfo from './assetLedgerPlanningInfo.vue';
	export default {
		name: 'AssetLedgerDrawer',
		components: {
			AssetLedgerBaseInfo,
			AssetLedgerDynamicRecording,
			AssetLedgerRelatedResource,
			AssetLedgerPlanningInfo,
		},
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.activeName = '1';
						this.fetchGetAssetById(this.data.id);
					});
				}
			},
		},
		data() {
			return {
				activeName: '1',
				detailData: {},
			};
		},
		computed: {
			assetChangeTitle() {
				const length = (this.detailData.assetChangeList && this.detailData.assetChangeList.length) || 0;
				if (length) return `动态记录(${length})`;
				return '动态记录';
			},
			assetResourceTitle() {
				const length = (this.detailData.resourceList && this.detailData.resourceList.length) || 0;
				if (length) return `关联资源(${length})`;
				return '关联资源';
			},
		},
		methods: {
			async fetchGetAssetById(id) {
				try {
					const res = await getAssetById(id);
					this.detailData = res;
				} catch (err) {
					console.log(err);
				}
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
		},
	};
</script>

<style scoped lang="scss">
	.drawer-content {
		padding: 10px 24px;
		color: #666;
	}
</style>
